import Icon from "@ant-design/icons";
import React from "react";

export default function ReportChartIcon() {
  return <Icon className="ac-icon" component={IconSvg} />;
}

const IconSvg = () => {
  return (
    <svg
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.75 5.5C6.41848 5.5 6.10054 5.6317 5.86612 5.86612C5.6317 6.10054 5.5 6.41848 5.5 6.75V14.25C5.5 14.5815 5.6317 14.8995 5.86612 15.1339C6.10054 15.3683 6.41848 15.5 6.75 15.5H17.25C17.5815 15.5 17.8995 15.3683 18.1339 15.1339C18.3683 14.8995 18.5 14.5815 18.5 14.25V6.75C18.5 6.41848 18.3683 6.10054 18.1339 5.86612C17.8995 5.6317 17.5815 5.5 17.25 5.5H6.75ZM4.80546 4.80546C5.32118 4.28973 6.02065 4 6.75 4H17.25C17.9793 4 18.6788 4.28973 19.1945 4.80546C19.7103 5.32118 20 6.02065 20 6.75V14.25C20 14.9793 19.7103 15.6788 19.1945 16.1945C18.6788 16.7103 17.9793 17 17.25 17H14.8058L15.8978 18.8721C16.1065 19.2299 15.9857 19.6891 15.6279 19.8978C15.2701 20.1065 14.8109 19.9857 14.6022 19.6279L13.0692 17H10.9308L9.39783 19.6279C9.18912 19.9857 8.72989 20.1065 8.3721 19.8978C8.01431 19.6891 7.89346 19.2299 8.10217 18.8721L9.19422 17H6.75C6.02065 17 5.32118 16.7103 4.80546 16.1945C4.28973 15.6788 4 14.9793 4 14.25V6.75C4 6.02065 4.28973 5.32118 4.80546 4.80546ZM8.75 8C9.16421 8 9.5 8.33579 9.5 8.75V12.25C9.5 12.6642 9.16421 13 8.75 13C8.33579 13 8 12.6642 8 12.25V8.75C8 8.33579 8.33579 8 8.75 8ZM12 9C12.4142 9 12.75 9.33579 12.75 9.75V12.25C12.75 12.6642 12.4142 13 12 13C11.5858 13 11.25 12.6642 11.25 12.25V9.75C11.25 9.33579 11.5858 9 12 9ZM15.25 10C15.6642 10 16 10.3358 16 10.75V12.25C16 12.6642 15.6642 13 15.25 13C14.8358 13 14.5 12.6642 14.5 12.25V10.75C14.5 10.3358 14.8358 10 15.25 10Z"
        fill="currentColor"
      />
    </svg>
  );
};
